var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass:
        "sidebar-cart__list-item sidebar-cart__list-item--configurable",
      class: {
        "sidebar-cart__list-item--editable": _vm.editable,
        "sidebar-cart__list-item--restricted": _vm.restricted
      }
    },
    [
      _c("div", { staticClass: "sidebar-cart__list-item-info" }, [
        _c("div", { staticClass: "sidebar-cart__list-item-info-wrapper" }, [
          _c("span", {
            staticClass: "sidebar-cart__list-item-name",
            domProps: {
              innerHTML: _vm._s(_vm.item.detailedName || _vm.item.name)
            }
          }),
          _vm._v(" "),
          _vm.item.variant && !_vm.item.detailedName
            ? _c("span", {
                staticClass: "sidebar-cart__list-item-meta",
                domProps: { innerHTML: _vm._s(_vm.item.variant) }
              })
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.hasFeature("FEATURE_CART_ITEM_NOTES") && !_vm.item.disableNote
          ? _c(
              "button",
              {
                staticClass: "sidebar-cart__list-item-notes",
                class: {
                  "sidebar-cart__list-item-notes--active": _vm.item.notes
                },
                attrs: {
                  title: _vm.item.notes
                    ? _vm.$t("cart.notes.buttonTitleActive")
                    : _vm.$t("cart.notes.buttonTitleEmpty"),
                  disabled: _vm.locked || !_vm.editable || _vm.restricted
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("notes")
                  }
                }
              },
              [_c("SVGNote")],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-cart__list-item-quantity" }, [
        _c(
          "button",
          {
            staticClass: "sidebar-cart__list-item-quantity-minus",
            attrs: { disabled: _vm.locked || !_vm.editable || _vm.restricted },
            on: {
              click: function($event) {
                return _vm.$emit("remove")
              }
            }
          },
          [_c("SVGTrash")],
          1
        ),
        _vm._v(" "),
        _c("span", { staticClass: "sidebar-cart__list-item-quantity-value" }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "sidebar-cart__list-item-quantity-plus",
            attrs: { disabled: _vm.locked || !_vm.editable || _vm.restricted },
            on: {
              click: function($event) {
                return _vm.$emit("copy")
              }
            }
          },
          [_c("SVGDuplicate")],
          1
        )
      ]),
      _vm._v(" "),
      _c("span", {
        staticClass: "sidebar-cart__list-item-price",
        domProps: {
          innerHTML: _vm._s(
            _vm.$options.filters.fwgpricecent(_vm.item.originalTotal, "short")
          )
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sidebar-cart__list-item-details" },
        [
          _vm.childCount
            ? _c("a", {
                staticClass: "sidebar-cart__list-item-options-trigger",
                class: {
                  "sidebar-cart__list-item-options-trigger--open":
                    _vm.showOptions
                },
                domProps: { innerHTML: _vm._s(_vm.optionsTrigger) },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.toggleOptions.apply(null, arguments)
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("Button", {
            staticClass: "sidebar-cart__list-item-edit",
            attrs: {
              type: "button",
              level: "tertiary",
              text: _vm.$t("cart.itemEdit"),
              arrow: "",
              disabled:
                _vm.locked || !_vm.editable || _vm.outside || _vm.restricted
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.$emit("edit")
              }
            }
          }),
          _vm._v(" "),
          _vm.childCount && _vm.showOptions
            ? _c(
                "div",
                { staticClass: "sidebar-cart__list-item-options-wrapper" },
                [
                  _vm.selectedOptions
                    ? _c("div", {
                        staticClass: "sidebar-cart__list-item-options",
                        domProps: { innerHTML: _vm._s(_vm.selectedOptions) }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedExtras
                    ? _c(
                        "div",
                        { staticClass: "sidebar-cart__list-item-extras" },
                        [
                          _vm.selectedOptions
                            ? _c("span", {
                                staticClass: "sidebar-cart__list-item-subtitle",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("childproducts.extrasTitle")
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "sidebar-cart__list-item-options",
                            domProps: { innerHTML: _vm._s(_vm.selectedExtras) }
                          })
                        ]
                      )
                    : _vm._e()
                ]
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }